import { defineComponent as Q, useAttrs as G, ref as i, computed as p, toRef as r, watch as J, createElementBlock as u, openBlock as n, Fragment as X, createBlock as b, createCommentVNode as f, normalizeClass as Y, unref as w, createElementVNode as V, toDisplayString as Z, mergeProps as _, withKeys as y, withModifiers as A, createTextVNode as k, renderSlot as I } from "vue";
import { useCodeMirror as ee, useDropdown as oe, colorPicker as le } from "@scalar/use-codemirror";
import { nanoid as te } from "nanoid";
import ne from "../../views/Environment/EnvironmentVariableDropdown.vue.js";
import x from "../DataTable/DataTableInputSelect.vue.js";
import { pillPlugin as ae, backspaceCommand as re } from "./codeVariableWidget.js";
import { useLayout as se } from "../../hooks/useLayout.js";
const ue = { class: "whitespace-nowrap" }, ie = ["id"], de = {
  key: 0,
  class: "z-context text-c-2 absolute right-1.5 bottom-1 hidden font-sans group-has-[:focus-visible]/input:block",
  role: "alert"
}, pe = {
  key: 5,
  class: "centered-y text-orange absolute right-7 text-xs"
}, fe = {
  key: 6,
  class: "centered-y absolute right-0 flex h-full items-center p-1.5 group-has-[.cm-focused]:z-1"
}, me = {
  key: 7,
  class: "required centered-y text-xxs text-c-3 group-[.error]:text-red bg-b-1 pointer-events-none absolute right-0 mr-0.5 pt-px pr-2 opacity-100 shadow-[-8px_0_4px_var(--scalar-background-1)] transition-opacity duration-150 group-[.alert]:bg-transparent group-[.alert]:shadow-none group-[.error]:bg-transparent group-[.error]:shadow-none peer-has-[.cm-focused]:opacity-0"
}, ce = {
  inheritAttrs: !1
}, ke = /* @__PURE__ */ Q({
  ...ce,
  __name: "CodeInput",
  props: {
    colorPicker: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    modelValue: {},
    error: { type: Boolean },
    emitOnBlur: { type: Boolean, default: !0 },
    extensions: { default: () => [] },
    lineNumbers: { type: Boolean },
    lint: { type: Boolean },
    disableTabIndent: { type: Boolean, default: !1 },
    language: {},
    handleFieldSubmit: {},
    handleFieldChange: {},
    placeholder: {},
    required: { type: Boolean },
    disableEnter: { type: Boolean, default: !1 },
    disableCloseBrackets: { type: Boolean, default: !1 },
    enum: {},
    examples: {},
    type: {},
    nullable: { type: Boolean, default: !1 },
    withVariables: { type: Boolean, default: !0 },
    importCurl: { type: Boolean },
    default: {},
    environment: {},
    envVariables: {},
    workspace: {},
    lineWrapping: { type: Boolean, default: !1 }
  },
  emits: ["submit", "update:modelValue", "curl", "blur"],
  setup(M, { expose: N, emit: O }) {
    var q;
    const o = M, s = O, B = G(), K = B.id || `id-${te()}`, C = i(!1), g = i(!1), S = i(""), D = i({ left: 0, top: 0 }), m = i(null), { layout: v } = se();
    function P(e) {
      var l;
      return e === o.modelValue ? null : o.importCurl && e.trim().toLowerCase().startsWith("curl") ? (s("curl", e), (l = a.value) == null || l.dispatch({
        changes: {
          from: 0,
          to: a.value.state.doc.length,
          insert: String(o.modelValue)
        }
      }), null) : o.handleFieldChange ? o.handleFieldChange(e) : s("update:modelValue", e);
    }
    function h(e) {
      return o.handleFieldSubmit ? o.handleFieldSubmit(e) : s("submit", e);
    }
    function E(e) {
      C.value = !1, o.emitOnBlur && o.modelValue && h(e), s("blur", e);
    }
    const F = [...o.extensions];
    o.colorPicker && F.push(le);
    const z = p(
      () => ae({
        environment: o.environment,
        envVariables: o.envVariables,
        workspace: o.workspace,
        isReadOnly: v === "modal"
      })
    ), L = p(() => [
      ...F,
      z.value,
      re
    ]), T = i(null), { codeMirror: a } = ee({
      content: r(
        () => o.modelValue !== void 0 ? String(o.modelValue) : ""
      ),
      onChange: (e) => {
        P(e), W();
      },
      onFocus: () => C.value = !0,
      onBlur: (e) => E(e),
      codeMirrorRef: T,
      disableTabIndent: r(() => o.disableTabIndent),
      disableEnter: r(() => o.disableEnter),
      disableCloseBrackets: r(() => o.disableCloseBrackets),
      lineNumbers: r(() => o.lineNumbers),
      language: r(() => o.language),
      lint: r(() => o.lint),
      extensions: L,
      placeholder: r(() => o.placeholder)
    });
    (q = a.value) == null || q.focus(), J(a, () => {
      a.value && Object.hasOwn(B, "autofocus") && a.value.focus();
    });
    const { handleDropdownSelect: U, updateDropdownVisibility: W } = oe({
      codeMirror: a,
      query: S,
      showDropdown: g,
      dropdownPosition: D
    }), $ = p(
      () => o.nullable ? ["true", "false", "null"] : ["true", "false"]
    ), c = (e, l) => {
      var d, t, R;
      g.value ? e === "down" ? (l.preventDefault(), (d = m.value) == null || d.handleArrowKey("down")) : e === "up" ? (l.preventDefault(), (t = m.value) == null || t.handleArrowKey("up")) : e === "enter" && (l.preventDefault(), (R = m.value) == null || R.handleSelect()) : e === "escape" ? o.disableTabIndent || l.stopPropagation() : e === "enter" && l.target instanceof HTMLDivElement && h(l.target.textContent ?? "");
    }, j = p(() => Array.isArray(o.type) ? (
      // Find the first type, that's not 'null'
      o.type.find((e) => e !== "null") ?? "string"
    ) : (
      // If it's not an array, just return the type
      o.type
    )), H = p(
      () => g.value && o.withVariables && v !== "modal" && o.environment
    );
    return N({
      /** Expose focus method */
      focus: () => {
        var e;
        (e = a.value) == null || e.focus();
      },
      // Expose these methods for testing
      handleChange: P,
      handleSubmit: h,
      handleBlur: E,
      booleanOptions: $,
      codeMirror: a,
      modelValue: o.modelValue
    }), (e, l) => {
      var d;
      return n(), u(X, null, [
        e.disabled ? (n(), u("div", {
          key: 0,
          class: Y(["text-c-2 flex cursor-default items-center justify-center", w(v) === "modal" ? "font-code pr-2 pl-1 text-base" : "px-2"]),
          "data-testid": "code-input-disabled"
        }, [
          V("span", ue, Z(e.modelValue), 1)
        ], 2)) : o.enum && o.enum.length ? (n(), b(x, {
          key: 1,
          default: o.default,
          modelValue: e.modelValue,
          type: j.value,
          value: o.enum,
          "onUpdate:modelValue": l[0] || (l[0] = (t) => s("update:modelValue", t))
        }, null, 8, ["default", "modelValue", "type", "value"])) : e.type === "boolean" || (d = e.type) != null && d.includes("boolean") ? (n(), b(x, {
          key: 2,
          default: o.default,
          modelValue: e.modelValue,
          value: $.value,
          "onUpdate:modelValue": l[1] || (l[1] = (t) => s("update:modelValue", t))
        }, null, 8, ["default", "modelValue", "value"])) : o.examples && o.examples.length ? (n(), b(x, {
          key: 3,
          default: o.default,
          modelValue: o.modelValue,
          value: o.examples,
          "onUpdate:modelValue": l[2] || (l[2] = (t) => s("update:modelValue", t))
        }, null, 8, ["default", "modelValue", "value"])) : (n(), u("div", _({
          key: 4,
          id: w(K)
        }, e.$attrs, {
          ref_key: "codeMirrorRef",
          ref: T,
          class: ["group/input group-[.alert]:outline-orange group-[.error]:outline-red font-code peer relative w-full overflow-hidden text-xs leading-[1.44] whitespace-nowrap -outline-offset-1 has-[:focus-visible]:rounded-[4px] has-[:focus-visible]:outline", {
            "line-wrapping has-[:focus-visible]:bg-b-1 has-[:focus-visible]:absolute has-[:focus-visible]:z-1": e.lineWrapping,
            "flow-code-input--error": e.error
          }],
          onKeydown: [
            l[3] || (l[3] = y(A((t) => c("down", t), ["stop"]), ["down"])),
            l[4] || (l[4] = y((t) => c("enter", t), ["enter"])),
            l[5] || (l[5] = y((t) => c("escape", t), ["escape"])),
            l[6] || (l[6] = y(A((t) => c("up", t), ["stop"]), ["up"]))
          ]
        }), [
          e.disableTabIndent ? f("", !0) : (n(), u("div", de, l[7] || (l[7] = [
            k(" Press "),
            V("kbd", { class: "-mx-0.25 rounded border px-0.5 font-mono" }, "Esc", -1),
            k(" then "),
            V("kbd", { class: "-mx-0.25 rounded border px-0.5 font-mono" }, "Tab", -1),
            k(" to exit ")
          ])))
        ], 16, ie)),
        e.$slots.warning ? (n(), u("div", pe, [
          I(e.$slots, "warning", {}, void 0, !0)
        ])) : f("", !0),
        e.$slots.icon ? (n(), u("div", fe, [
          I(e.$slots, "icon", {}, void 0, !0)
        ])) : f("", !0),
        e.required ? (n(), u("div", me, " Required ")) : f("", !0),
        H.value ? (n(), b(ne, {
          key: 8,
          ref_key: "dropdownRef",
          ref: m,
          dropdownPosition: D.value,
          envVariables: e.envVariables,
          environment: e.environment,
          query: S.value,
          onSelect: w(U)
        }, null, 8, ["dropdownPosition", "envVariables", "environment", "query", "onSelect"])) : f("", !0)
      ], 64);
    };
  }
});
export {
  ke as default
};
